module.exports = __webpack_public_path__ + "static/img/sou-s@2x.255cf67f.png";